export default class Observer {
  constructor({ isOnce = false, rootMargin = '0px 0px 0px 0px' } = {}) {
    this.isOnce = isOnce;
    this.rootMargin = rootMargin;
    this.isVisible = false;
    this.observer = null;

    this.createObserver();
  }

  createObserver() {
    if (!('IntersectionObserver' in window)) {
      this.animateIn();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateIn(entry.target);

            if (this.isOnce) {
              this.observer.unobserve(entry.target);
            }
          } else {
            this.animateOut(entry.target);
          }
        });
      },
      { rootMargin: this.rootMargin },
    );
  }

  observe(targets) {
    if (!this.observer) return;

    $(targets).each((_, target) => {
      this.observer.observe(target);
    });
  }

  unobserve(target) {
    if (!this.observer) return;

    $(target).each((_, item) => {
      this.observer.unobserve(item);
    });
  }

  animateIn() {
    this.isVisible = true;
  }

  animateOut() {
    this.isVisible = false;
  }
}
